import React, { type FC } from "react";
import {inject, observer} from "mobx-react";
import cn from "classnames";


import {useGlobalModule} from "@ok/web/hooks/useGlobalModule";
import {ClipsFullscreenController} from "../../../lib/ClipsFullscreenController";


import classes from "./Fade.styl";

export interface IFadeProps extends React.PropsWithChildren {
    ctrl?: ClipsFullscreenController;
}

export const Fade: FC<IFadeProps> = inject("ctrl")(observer(
    (props): React.ReactElement => {
        const ctrl = props.ctrl!;
        const store = ctrl.store;

        const createScrollLocker = useGlobalModule(() => window.OK.createScrollLocker).current;
        const scrollLocker = React.useMemo(() => createScrollLocker?.(), [createScrollLocker]);

        const closeOnBackGround = React.useCallback((e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            if (e.currentTarget === e.target) {
                ctrl.handleClose();
            }

        }, [ctrl]);

        React.useEffect(() => {
            if (!scrollLocker) {
                return;
            }

            if (store.isFullscreenOpen) {
                scrollLocker.lock();
            } else {
                scrollLocker.unlock();
            }

            return () => {
                scrollLocker.unlock();
            };
        }, [store.isFullscreenOpen, scrollLocker]);


        const faderClassName = cn(
            classes["fade"], {
                [classes["__open"]]: store.isFullscreenOpen
            }
        );

        return (
            <div
                className={faderClassName}
                onClick={closeOnBackGround}
            >
                {props.children}
            </div>
        );
    }
));
